/*!
  Atom, by Koding Themes
  atom-animations.js
  https://kodingthemes.com
*/

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother, SplitText);
var loaderCreated = false;
let globalAnimation = {
  stickyProductForm: function (e) {
    var productInfo = document.querySelector("#product-info");
    // Skip sticky form in carousel mode
    if (productInfo && productInfo.dataset.mediaStyle === "carousel") return;
    var stickyFormContainer = document.querySelector("#sticky-form-wrapper");
    if (stickyFormContainer == null) return;
    // Only attach once
    if (stickyFormContainer.dataset.stickyInit) return;
    // Find the add-to-cart button as the scroll trigger
    var addToCartBtn = document.querySelector("#product-info .add-to-cart-button");
    if (addToCartBtn == null) return;
    stickyFormContainer.dataset.stickyInit = "1";

    // Calculate top offset (below sticky header)
    var topOffset = 0;
    var stickyHeader = document.querySelector(".main-header-sticky");
    if (stickyHeader) {
      if (window.innerWidth >= 1008) {
        var navEl = document.querySelector("#shopify-section-primary-nav");
        topOffset = navEl ? navEl.offsetHeight : 0;
      } else {
        var navbar = document.querySelector(".primary-mobile-nav");
        topOffset = navbar ? navbar.offsetHeight : 0;
      }
    }

    if (Shopify.designMode) {
      // Design mode: use IntersectionObserver for reliable show/hide
      stickyFormContainer.style.top = topOffset + "px";
      stickyFormContainer.style.visibility = "hidden";
      stickyFormContainer.style.transform = "translateY(-100%)";
      stickyFormContainer.style.zIndex = "-1";
      stickyFormContainer.style.transition = "transform 0.4s ease, visibility 0s linear 0.4s";

      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          // Button has scrolled above the viewport — show sticky form
          stickyFormContainer.style.transition = "transform 0.4s ease, visibility 0s linear 0s";
          stickyFormContainer.style.visibility = "visible";
          stickyFormContainer.style.transform = "translateY(0)";
          stickyFormContainer.style.zIndex = "2";
        } else {
          // Button is visible or below viewport — hide sticky form
          stickyFormContainer.style.transition = "transform 0.4s ease, visibility 0s linear 0.4s";
          stickyFormContainer.style.transform = "translateY(-100%)";
          stickyFormContainer.style.zIndex = "-1";
          stickyFormContainer.style.visibility = "hidden";
        }
      }, { threshold: 0 });

      observer.observe(addToCartBtn);
      return;
    }

    // Live site: use ScrollTrigger
    gsap.set(stickyFormContainer, {
      top: topOffset,
      yPercent: -100,
      visibility: "visible",
    });

    var stickyFormInner = stickyFormContainer.querySelector(".sticky-form-container");

    ScrollTrigger.create({
      trigger: addToCartBtn,
      start: "bottom top",
      onEnter: function () {
        gsap.killTweensOf(stickyFormContainer);
        gsap.killTweensOf(stickyFormInner);
        gsap.set(stickyFormContainer, { zIndex: 2 });
        gsap.fromTo(stickyFormContainer,
          { yPercent: -100 },
          {
            yPercent: 0,
            duration: 0.6,
            ease: "power3.out",
          }
        );
        if (stickyFormInner) {
          gsap.fromTo(stickyFormInner,
            { opacity: 0, y: -10 },
            {
              opacity: 1,
              y: 0,
              duration: 0.4,
              delay: 0.2,
              ease: "power2.out",
            }
          );
        }
      },
      onLeaveBack: function () {
        gsap.killTweensOf(stickyFormContainer);
        gsap.killTweensOf(stickyFormInner);
        if (stickyFormInner) {
          gsap.to(stickyFormInner, {
            opacity: 0,
            y: -8,
            duration: 0.25,
            ease: "power2.in",
          });
        }
        gsap.to(stickyFormContainer, {
          yPercent: -100,
          duration: 0.45,
          delay: 0.1,
          ease: "power3.in",
          onComplete: function () {
            gsap.set(stickyFormContainer, { zIndex: -1 });
          },
        });
      },
    });
  },
  animationEffects: function (e) {
    // 1 - loading (skip in theme editor — disruptive while editing, only run once)
    if (document.querySelector(".loading-panels") != null && !Shopify.designMode && !loaderCreated) {
      loaderCreated = true;
      const loader = gsap.timeline({
        paused: true,
      });
      loader
        .to(
          ".loading-panels .loading-panel:first-child, .loading-panels .loading-panel:last-child",
          {
            scaleY: 1,
            duration: 1,
          }
        )
        .to(
          ".loading-panels .loading-panel:not(:first-child):not(:last-child)",
          {
            scaleY: 1,
          },
          "-=0.5"
        )
        .to(".loading-panels .loading-panel", {
          scaleY: 0,
          duration: 0.3,
          stagger: 0.05,
        })
        .to(".loading-panels", {
          clipPath: "circle(0%)",
          skewX: 0,
          duration: 1,
          onComplete: function () {
            var panels = document.querySelector(".loading-panels");
            if (panels) {
              panels.remove();
            }
          },
        });
      window.addEventListener("load", function () {
        loader.play();
      });
      window.addEventListener("resize", function () {
        if (document.querySelector(".loading-panels") != null) {
          document.querySelector(".loading-panels").style.display = "none";
        }
      });
    }
    // 2 - animate sections
    if (document.body.getAttribute("id") != "product") {
      if (document.body.getAttribute("id") != "collection") {
        var shopifySections = gsap.utils.toArray(".shopify-section");
        if (shopifySections != null) {
          gsap.set(".shopify-section", {
            clearProps: true,
          });
          ScrollTrigger.matchMedia({
            "(min-width: 1008px)": function () {
              shopifySections.forEach((sectionItem, i) => {
                sectionItem.classList.add("animation-applied-element");
                if (
                  sectionItem.querySelector("header") == null &&
                  sectionItem.querySelector(".main-footer") == null &&
                  sectionItem.querySelector(".footer-newsletter") == null
                ) {
                  // Skip scroll-fade for sections already in the viewport (e.g. hero banner)
                  // so the LCP element is never hidden by autoAlpha: 0
                  var rect = sectionItem.getBoundingClientRect();
                  if (rect.top < window.innerHeight) return;

                  var anim1 = gsap.fromTo(
                    sectionItem,
                    {
                      autoAlpha: 0,
                      y: 150,
                    },
                    {
                      duration: 1,
                      autoAlpha: 1,
                      y: 0,
                    }
                  );
                  ScrollTrigger.create({
                    trigger: sectionItem,
                    animation: anim1,
                    start: "top 100%",
                    end: "top 50%",
                    markers: false,
                    scrub: 1.5,
                  });
                }
              });
            },
          });
        }
      }
    }
    //3 - welcome text animation
    if (document.querySelector(".js-section-title") != null) {
      gsap.set(".js-section-title", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          let welcomeText = gsap.utils.toArray(".js-section-title");
          const sectionTitle = gsap.timeline({
            scrollTrigger: {
              trigger: welcomeText,
              start: "top 90%",
              end: "bottom 60%",
              scrub: 2,
              markers: false,
              toggleActions: "play none play reset",
            },
          });
          const welcomeSplit = new SplitText(welcomeText, {
            type: "lines",
          });
          sectionTitle.from(welcomeSplit.lines, {
            y: 100,
            opacity: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: "back.inOut",
          });
        },
      });
    }
    //4 - product description animation
    if (document.querySelector(".section-product-tabs") != null) {
      let splitTextLines = gsap.utils.toArray(".product-overview__text");
      gsap.set(".product-overview__text", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: splitTextLines,
              start: "top 90%",
              end: "top 20%",
              scrub: 2,
              markers: false,
              toggleActions: "play none play reset",
            },
          });
          const itemSplitted = new SplitText(splitTextLines, {
            type: "lines",
          });
          tl.from(itemSplitted.lines, {
            y: 100,
            opacity: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: "back.inOut",
          });
        },
      });
    }
    // 5 - product page sticky product info
    if (document.body.getAttribute("id") == "product") {
      var productInfo = document.querySelector("#product-info");
      var isCarousel = productInfo && productInfo.dataset.mediaStyle === "carousel";
      if (productInfo && !isCarousel) {
        if (Shopify.designMode) {
          // Design mode: manual fixed positioning on scroll
          // (CSS sticky breaks in theme editor, GSAP pin causes payment button flicker)
          var stickyHeader = document.querySelector(".main-header-sticky") || document.querySelector(".mobile-header-sticky");
          var headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
          // Skip sticky product-info on mobile (single column layout)
          if (window.innerWidth < 768) return;

          var parentCol = productInfo.closest(".product-info");
          var productRow = productInfo.closest(".row");
          var mediaCol = productRow ? productRow.querySelector(".slideshow-wrap") : null;
          // Only pin when media column is taller than product info (stacked mode)
          if (!mediaCol || mediaCol.offsetHeight <= productInfo.offsetHeight) return;

          var infoWidth = productInfo.getBoundingClientRect().width + "px";
          window.addEventListener("resize", function () {
            productInfo.style.position = "";
            productInfo.style.width = "";
            infoWidth = productInfo.getBoundingClientRect().width + "px";
          });

          window.addEventListener("scroll", function () {
            if (!parentCol || !mediaCol) return;
            var parentRect = parentCol.getBoundingClientRect();
            var mediaRect = mediaCol.getBoundingClientRect();
            var pinEnd = mediaRect.bottom - productInfo.offsetHeight - headerOffset;

            if (parentRect.top <= headerOffset && pinEnd > 0) {
              productInfo.style.position = "fixed";
              productInfo.style.top = headerOffset + "px";
              productInfo.style.width = infoWidth;
            } else if (pinEnd <= 0) {
              productInfo.style.position = "absolute";
              productInfo.style.top = "auto";
              productInfo.style.bottom = "0";
              productInfo.style.width = infoWidth;
            } else {
              productInfo.style.position = "";
              productInfo.style.top = "";
              productInfo.style.width = "";
              productInfo.style.bottom = "";
            }
          });
          if (parentCol) {
            parentCol.style.position = "relative";
          }
        } else {
          // Storefront: use ScrollTrigger pin (works with ScrollSmoother)
          ScrollTrigger.matchMedia({
            "(min-width: 768px)": function () {
              var productRow = productInfo.closest(".row");
              var mediaCol = productRow
                ? productRow.querySelector(".slideshow-wrap")
                : null;
              if (productRow && mediaCol) {
                var pinDistance =
                  mediaCol.offsetHeight - productInfo.offsetHeight;
                if (pinDistance > 0) {
                  var headerOffset = 0;
                  var stickyHeader =
                    document.querySelector(".main-header-sticky");
                  if (stickyHeader) {
                    headerOffset = stickyHeader.offsetHeight;
                  }
                  var parentCol = productInfo.closest(".product-info");
                  ScrollTrigger.create({
                    trigger: productInfo,
                    start: "top top+=" + headerOffset,
                    end: "+=" + pinDistance,
                    pin: true,
                    pinSpacing: false,
                    pinType: "transform",
                    markers: false,
                    onRefresh: function () {
                      if (parentCol) {
                        productInfo.style.maxWidth = parentCol.clientWidth + "px";
                      }
                    },
                  });
                }
              }
            },
          });
        }
      }
      // 6 - ensure sections below product are visible (no scroll animations on product page)
      var sections = gsap.utils.toArray(".shopify-section");
      if (sections != null) {
        sections.forEach((section, i) => {
          if (section.querySelector("#product-form") == null) {
            gsap.set(section, { clearProps: "all" });
          }
        });
      }
    }
    // 7 - Entire site scroll (skip in design mode — ScrollSmoother conflicts with editor)
    if (
      document.querySelector(".main-container") != null &&
      document.querySelector(".main-sidebar") != null &&
      !Shopify.designMode
    ) {
      gsap.set(".main-container", {
        clearProps: true,
      });
      gsap.set(".main-sidebar", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 1008px)": function () {
          var headerSectionsHeight = 0;
          if (document.querySelector(".tpro-wrapper-index-1") != null) {
            var headerSections = document.querySelectorAll(
              ".shopify-section-group-header-group"
            );
            if (headerSections.length > 0) {

              headerSections.forEach(function (headerSection) {
                if (
                  headerSection.classList.contains(
                    "index-sidebar-navigation"
                  ) == false
                ) {
                  headerSectionsHeight =
                    headerSectionsHeight + headerSection.clientHeight;
                }
              });
              gsap.set(".main-sidebar .left-side", {
                top: -headerSectionsHeight,
              });
            }
          }

          let triggers = ScrollTrigger.getAll();
          triggers.forEach((trigger) => {
            var triggers = trigger.vars.trigger;
            if (triggers == ".main-container") {
              trigger.kill();
            }
          });
          gsap.set(".main-sidebar .left-side", {
            x: 0,
          });
          gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
          ScrollSmoother.create({
            content: ".main-container",
            smooth: 2,
            effects: false,
            smoothTouch: 1.5,
          });
          ScrollTrigger.create({
            trigger: ".main-container",
            start: "top top",
            end: "bottom+=1000% bottom",
            pin: ".main-sidebar",
            anticipatePin: 1,
            normalizeScroll: true,
            pinSpacing: false,
            markers: false,
          });
          // Move .left-side out of pin-spacer so its position:fixed
          // is not trapped by ScrollTrigger's transform containing block
          var leftSide = document.querySelector(".left-side");
          if (leftSide) {
            document.body.appendChild(leftSide);
            leftSide.style.transform = "translateX(100%)";
          }
          if (document.querySelector(".main-header-sticky") != null) {
            if (document.querySelector(".tpro-wrapper-index-1") != null) {
               window.addEventListener("scroll",(e) => {
                if(window.scrollY < headerSectionsHeight) {
                    gsap.to(".main-header-sticky", {
                        top: 0,
                        duration: .3,
                        delay: 1
                    });
                } else {
                  gsap.to(".main-header-sticky", {
                      top: -headerSectionsHeight,
                      duration: .1,
                  });
                }
               });
            }

            ScrollTrigger.create({
              trigger: ".main-container",
              start: "top top",
              pin: ".main-header-sticky",
              anticipatePin: 1,
              normalizeScroll: true,
              pinSpacing: false,
              markers: false,
              onUpdate: function () {
                var header = document.querySelector(".main-header-sticky");
                if (header) {
                  var scrollY = window.pageYOffset || document.documentElement.scrollTop;
                  if (scrollY > header.offsetHeight) {
                    header.classList.add("header-scrolled");
                  } else {
                    header.classList.remove("header-scrolled");
                  }
                }
              },
            });
            // Ensure pinned header stacks above the sticky product form
            var pinnedHeader = document.querySelector(".main-header-sticky");
            if (pinnedHeader) {
              pinnedHeader.style.zIndex = "11";
              // ScrollTrigger wraps pinned elements in a pin-spacer div
              if (pinnedHeader.parentElement && pinnedHeader.parentElement.classList.contains("pin-spacer")) {
                pinnedHeader.parentElement.style.zIndex = "11";
              }
            }
          }
        },
      });
    }
    // flicker debugger (skip .main-sidebar in design mode — will-change creates
    // a containing block that breaks .left-side fixed positioning)
    window.addEventListener("load", (event) => {
      var flickerSelectors = [
        ".collection-sorting.filter-wrapper",
        ".main-header-sticky",
        ".product-grid",
        "#page-cart",
      ];
      if (!Shopify.designMode) {
        flickerSelectors.push("#product-info");
      }
      flickerSelectors.forEach(function (sl, index) {
        var item = document.querySelector(sl);
        if (item != null) {
          item.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
    window.addEventListener("load", (event) => {
      var productImgDsk = [".product-media-desktop-only"];
      productImgDsk.forEach(function (item, index) {
        var productItem = document.querySelector(item);
        if (productItem != null) {
          productItem.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
  },
};
//events
document.addEventListener("DOMContentLoaded", function (e) {
  globalAnimation.animationEffects(e);
  if (window.theme.stickyHeader) {
    globalAnimation.stickyProductForm(e);
  }
});
document.addEventListener("shopify:section:load", function (e) {
  globalAnimation.animationEffects(e);
  if (window.theme.stickyHeader) {
    globalAnimation.stickyProductForm(e);
  }
});
document.addEventListener("shopify:section:unload", function (e) {
  globalAnimation.animationEffects(e);
  if (window.theme.stickyHeader) {
    globalAnimation.stickyProductForm(e);
  }
});
document.addEventListener("shopify:section:reorder", function (e) {
  globalAnimation.animationEffects(e);
  if (window.theme.stickyHeader) {
    globalAnimation.stickyProductForm(e);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var checkbox = document.querySelector(".RecipientCheckbox");
  if (checkbox != null) {
    checkbox.addEventListener("click", function (e) {
      globalAnimation.animationEffects(e);
      if (window.theme.stickyHeader) {
        globalAnimation.stickyProductForm(e);
      }
    });
  }
  var accs = document.querySelectorAll(".product-accordion-item .faq-title");
  if (accs.length > 0) {
    accs.forEach(function (acc) {
      acc.onclick = function (e) {
        if (window.theme.stickyHeader) {
          globalAnimation.animationEffects(e);
        }
      };
    });
  }
});
if (Shopify.designMode == true) {
  if (document.querySelector("#product-info") != null) {
    document.addEventListener("shopify:section:load", function (e) {
      if (window.theme.stickyHeader) {
        globalAnimation.stickyProductForm(e);
      }
    });
  }
  // sticky header on theme editor
  var stickyContainer = document.querySelector(".main-header-sticky");
  if (stickyContainer != null) {
    var headerHeight = stickyContainer.offsetHeight;
    var lastScrollY = 0;
    var isHeaderFixed = false;
    // Create spacer once, hidden by default
    var headerSpacer = document.createElement("div");
    headerSpacer.style.height = headerHeight + "px";
    headerSpacer.style.display = "none";
    stickyContainer.parentNode.insertBefore(headerSpacer, stickyContainer);
    // Smooth transition for the header
    stickyContainer.style.transition = "transform 0.3s ease";

    window.addEventListener("scroll", function () {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var scrollingDown = scrollY > lastScrollY;
      lastScrollY = scrollY;

      if (scrollY <= 0) {
        // At top of page — fully release header
        isHeaderFixed = false;
        stickyContainer.classList.remove("header-scrolled");
        stickyContainer.style.transform = "";
        headerSpacer.style.display = "none";
      } else if (scrollY > headerHeight * 2 && scrollingDown && !isHeaderFixed) {
        // Scrolling down past threshold — fix and slide in
        isHeaderFixed = true;
        headerSpacer.style.display = "block";
        stickyContainer.style.transform = "translateY(-100%)";
        stickyContainer.classList.add("header-scrolled");
        // Force reflow then slide in
        stickyContainer.offsetHeight;
        stickyContainer.style.transform = "translateY(0)";
      } else if (!scrollingDown && isHeaderFixed && scrollY <= headerHeight) {
        // Scrolling up near top — release back to flow
        isHeaderFixed = false;
        stickyContainer.style.transform = "";
        stickyContainer.classList.remove("header-scrolled");
        headerSpacer.style.display = "none";
      }
    });
  }
}

// sticky header on mobile
if (document.querySelector(".mobile-header-sticky") != null) {
  document.addEventListener("DOMContentLoaded", function (e) {
    const navbar = document.querySelector(".primary-mobile-nav");
    const mainNavbar = document.querySelector(".main-header-sticky");
    window.addEventListener(
      "scroll",
      function (event) {
        if (window.scrollY == 0) {
          if (navbar != null) {
            navbar.classList.add("position-relative");
            navbar.classList.remove("position-fixed");
            navbar.classList.remove("sticky-mobile");
          }
        }
      },
      false
    );
    const stickyNav = function (entries) {
      const [entry] = entries;
      if (!entry.isIntersecting) {
        //header
        navbar.classList.remove("position-relative");
        navbar.classList.add("position-fixed");
        navbar.classList.add("sticky-mobile");
      } else {
        return;
      }
    };
    const headerObserver1 = new IntersectionObserver(stickyNav, {
      root: null,
      threshold: 0,
      rootMargin: "0px",
    });
    if (navbar != null) {
      headerObserver1.observe(navbar);
    }
  });
}
